import React from 'react';
import { Paper, Typography } from '@mui/material';

/**
 * Single KPI tile — uppercase label, big number, optional hint line.
 * Used on Overview, LowStock, Discounts.
 *
 *   <KpiCard label="Orders today" value={42} hint="Revenue $1,200" />
 */
export default function KpiCard({ label, value, hint, accent }) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '16px',
        p: '18px',
        // On a dark page a 4%-black shadow is invisible; the card would be
        // separated only by its own fill. Deepen it so the layering survives.
        boxShadow: (t) => (t.palette.mode === 'dark'
          ? '0 4px 16px rgba(0,0,0,0.45)'
          : '0 4px 16px rgba(0,0,0,0.04)'),
      }}
    >
      <Typography
        variant='caption'
        color='text.secondary'
        textTransform='uppercase'
        fontWeight='700'
        display='block'
        mb='6px'
      >
        {label}
      </Typography>
      <Typography
        variant='h5'
        fontWeight='800'
        sx={accent ? { color: accent } : undefined}
      >
        {value}
      </Typography>
      {hint && (
        <Typography variant='caption' color='text.secondary' display='block' mt='4px'>
          {hint}
        </Typography>
      )}
    </Paper>
  );
}
